import { useCallback, useEffect, useState } from "react";
import {
  IEstablishmentCollector,
  IModalCollector,
} from "../../../../models/collectors";
import { useTranslation } from "react-i18next";
import CollectorService from "../../../../services/collector.service";
import NoData from "../../../../components/Logs/NoData/NoData";
import CustomLoading from "../../../../components/CustomLoading";
import PrettyJson from "./PrettyJson";
import OnPremiseHeader from "./OnPremiseHeader";
import { useFetch } from "@4uhub/lib4uhub";

const ESTABLISHMENT_COLLECTOR_ROUTE =
  process.env.REACT_APP_COLLECTOR + "/api/v1/Establishment/Collector/";
const establishmentService = new CollectorService<IEstablishmentCollector>(
  ESTABLISHMENT_COLLECTOR_ROUTE
);

const translationPath = "components.onPremiseModal.establishment.";

const EstablishmentOnPremise = ({
  modalCollector,
}: {
  modalCollector: IModalCollector | undefined;
}) => {
  const { t } = useTranslation();
  const [collector, setCollector] = useState<IEstablishmentCollector[]>([]);

  const { sendRequest, loading } = useFetch(establishmentService.getAll);

  const loadCollector = useCallback(async () => {
    if (modalCollector) {
      const { data } = await sendRequest(modalCollector.establishmentId);
      if (data) {
        setCollector(data);
      }
    }
  }, [sendRequest, modalCollector]);

  useEffect(() => {
    loadCollector();
  }, [loadCollector]);

  return (
    <>
      {loading && <CustomLoading />}
      <OnPremiseHeader>
        {collector.length > 0 && <PrettyJson>{collector}</PrettyJson>}
        {!loading && collector.length === 0 && (
          <NoData message={t(translationPath + "no_data")} />
        )}
      </OnPremiseHeader>
    </>
  );
};

export default EstablishmentOnPremise;
